'use client'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useRef, type ReactNode } from 'react'
import { useMountEffect } from '@/hooks/useMountEffect'
import copy from '../_content/site-copy.json'
import { Wordmark } from './Wordmark'
export function MuseumNav({ children }: { children?: ReactNode }) {
  const pathname = usePathname()
  const menu = useRef<HTMLDetailsElement>(null)
  useMountEffect(() => {
    const escape = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && menu.current?.open) {
        menu.current.open = false
        menu.current.querySelector('summary')?.focus()
      }
    }
    document.addEventListener('keydown', escape)
    return () => document.removeEventListener('keydown', escape)
  })
  const links = (['exhibits', 'index', 'timeline'] as const).map((key) => (
    <Link
      key={key}
      href={`/museum/${key}`}
      aria-current={pathname === `/museum/${key}` ? 'page' : undefined}
      onClick={() => {
        if (menu.current) menu.current.open = false
      }}
    >
      <span aria-hidden="true" />
      {copy.nav[key]}
    </Link>
  ))
  return (
    <header className="museum-nav">
      <div className="museum-nav-top">
        <Link href="/museum" aria-label={copy.nav.home}>
          <Wordmark />
        </Link>
        <div className="museum-nav-toplinks">
          <Link href="/craft">
            arne.ai<span aria-hidden="true"> ↗</span>
          </Link>
        </div>
        <details className="museum-nav-mobile" ref={menu}>
          <summary aria-label={copy.nav.home}>
            <span aria-hidden="true">☰</span>
          </summary>
          <nav>
            {links}
            <Link href="/craft">arne.ai ↗</Link>
          </nav>
        </details>
      </div>
      <div
        className="museum-nav-controls"
        data-filters={children ? 'true' : undefined}
      >
        <nav className="museum-tabs" aria-label={copy.nav.home}>
          {links}
        </nav>
        {children}
      </div>
    </header>
  )
}
